import React, { useState } from "react";
import ChildTransaction from "../../Modals/Payment/ChildTransaction/ChildTransaction";
import { useSelector } from "react-redux";
import { walletChildTransaction } from "../../../Services/Payments/PaymentApi";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";
import Styles from "./Contracts.module.css";
import DetailHeader from "../DetailsHeader/DetailHeader";
import { formatDateType } from "../../../commons/FormatDate";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Contracts = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const data = useSelector((state) => state?.paymentSlice);
  let contracts = data?.walletContract;

  const [childTransaction, setChildTransaction] = useState([]);
  const [parentData, setParentData] = useState({});
  const handleChildTransaction = async (data) => {
    console.debug(data);
    setParentData(data);
    let res = await walletChildTransaction(data?.id);
    if (res?.data?.code === 200) {
      setChildTransaction(res?.data?.data || []);
    } else {
      ErrorMessage(res?.data?.message || "Something went wrong");
    }
  };

  const handleSelect = () => {};

  return (
    <>
      {
        <ChildTransaction
          open={childTransaction?.length > 0}
          handleClose={() => setChildTransaction([])}
          data={childTransaction}
          parentData={parentData}
        />
      }
      <div style={{ width: "100%", height: "100%" }}>
        <DetailHeader
          heading={"Contracts"}
          handleSelect={handleSelect}
          list={
            [
              // { name: "All", value: "all", status: true },
              // { name: "Ongoing", value: "ongoing", status: false },
              // { name: "Completed", value: "completed", status: false },
              // { name: "Pending", value: "pending", status: false },
            ]
          }
        />
        <div className={Styles.tableMainElem}>
          <div
            className={`display_flex_row tableHeading ${Styles.headingMainTable}`}
          >
            <div style={{ width: "10%" }}>Contract Id</div>
            <div style={{ width: "10%" }}>Self Listing</div>
            <div style={{ width: "10%" }}>Counterparty</div>
            <div style={{ width: "10%" }}>Start and End Date</div>
            <div style={{ width: "10%" }}>Total Contract Value (₹)</div>
            <div style={{ width: "10%" }}>Amount Price (₹)</div>
            <div style={{ width: "10%" }}>Total Contract Schedule (MWH)</div>
            <div style={{ width: "10%" }}>Actual Delivery (MWH)</div>
            <div style={{ width: "10%" }}>Schedule</div>
            <div style={{ width: "5%" }}>Details</div>
          </div>
          <div className={`scroll_bar_y ${Styles.viewMainElem}`}>
            {contracts?.map((ele) => (
              <div className="display_flex_row tableDetails">
                <div style={{ width: "10%" }}>
                  {ele?.bilateralContractUniqueId || "-"}
                </div>
                <div style={{ width: "10%" }}>
                  {(role === "consumer"
                    ? ele?.name?.split("-")?.[0]?.includes("C")
                      ? ele?.name?.split("-")?.[0]
                      : ele?.name?.split("-")?.[1]
                    : ele?.name?.split("-")?.[1]?.includes("G")
                    ? ele?.name?.split("-")?.[1]
                    : ele?.name?.split("-")?.[0]
                  )?.split("_")?.[0] || "-"}
                </div>
                <div style={{ width: "10%" }}>
                  {role === "consumer"
                    ? `${ele?.generatorName || "-"}`
                    : role === "generator"
                    ? `${ele?.consumerName || "-"}`
                    : `${ele?.consumerName}-${ele?.generatorName}`}
                </div>
                <div style={{ width: "10%" }}>
                  {`${formatDateType(ele?.startDate)} to ${formatDateType(
                    ele?.endDate
                  )}`}
                </div>
                <div style={{ width: "10%" }}>
                  {ele?.scheduleAmount?.toFixed(2)}
                </div>
                <div style={{ width: "10%" }}>
                  {ele?.amountBlocked?.toFixed(2)}
                </div>
                <div style={{ width: "10%" }}>{ele?.volume?.toFixed(2)}</div>
                <div style={{ width: "10%" }}>
                  {ele?.deliveredVolume?.toFixed(2)}
                </div>
                <div
                  style={{ width: "10%" }}
                  className={`${
                    ele?.status === "COMPLETED"
                      ? "accepted"
                      : ele?.status === "PENDING"
                      ? "pending"
                      : "rejected"
                  }`}
                >
                  {ele?.status === "COMPLETED"
                    ? "Completed"
                    : ele?.status === "PENDING"
                    ? "Ongoing"
                    : "Rejected"}
                </div>
                <div
                  style={{ width: "5%" }}
                  onClick={() => {
                    handleChildTransaction(ele);
                  }}
                >
                  <VisibilityIcon
                    style={{ fontSize: "14px", color: "#f1935c" }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contracts;
